import React from 'react';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
	ChartWrapper,
	TooltipWrapper,
	TooltipHeader,
	TooltipRowTitle,
	TooltipRowValue,
	TooltipGrid,
	ColorWrapper,
	ColorSymbol,
	TooltipRowPinned,
} from './CommonVendorsChart.styles';
import { colors } from '@alixpartners/ui-components';
import { renderToString } from 'react-dom/server';
import numeral from 'numeral';
import { makeUnknownFromEmpty } from '../../utils';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';

export class CommonVendorsChart extends React.Component {
	chart = null;

	componentDidUpdate(prevProps) {
		const { isLoading } = this.props;

		if (isLoading !== prevProps.isLoading && this.chart) {
			if (!isLoading) {
				this.chart.hideLoading();
			} else {
				this.chart.showLoading();
			}
		}
	}

	getChartOptions = () => {
		const {
			spendFormatter,
			series,
			categories,
			currencySymbol,
			hideDecimals,
		} = this.props;

		return {
			chart: {
				type: 'column',
				marginTop: 40,
				style: { fontFamily: 'Roboto' },
			},
			title: {
				text: '',
			},
			exporting: { enabled: false, allowHTML: true },
			credits: {
				enabled: false,
			},
			loading: {
				hideDuration: 500,
				showDuration: 500,
				labelStyle: {
					fontWeight: 'normal',
					letterSpacing: '0.3px',
				},
			},
			xAxis: {
				title: {
					enabled: false,
				},
				lineColor: 'black',
				categories,
				labels: {
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey7,
					},
				},
				gridLineWidth: 0,
			},
			yAxis: {
				title: {
					align: 'high',
					text: 'Spend',
					textAlign: 'right',
					rotation: 0,
					y: -30,
					offset: 15,
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey7,
					},
				},
				gridLineWidth: 0,
				labels: {
					formatter: function() {
						return formatSpendWithDecimalAndSymbol(
							this.value,
							currencySymbol,
							hideDecimals,
							0
						).toUpperCase();
					},
					style: {
						fontSize: '11px',
						fontWeight: '400',
						lineHeight: '13px',
						letterSpacing: 0,
						color: colors.grey7,
					},
				},
				stackLabels: {
					enabled: true,
					align: 'center',
					formatter: function() {
						return spendFormatter(this.total);
					},
					style: {
						fontSize: '12px',
						fontWeight: '500',
						lineHeight: '12px',
						letterSpacing: 0.3,
						color: colors.grey7,
					},
				},
				lineColor: 'black',
				lineWidth: 1,
			},
			legend: {
				enabled: false,
				symbolRadius: 1,
				symbolHeight: 16,
				symbolPadding: 8,
				itemDistance: 32,
				useHTML: true,
				itemMarginTop: 5,
				itemMarginBottom: 5,
				itemStyle: {
					color: colors.grey7,
					cursor: 'pointer',
					fontSize: '11px',
					fontWeight: 'normal',
					textOverflow: 'ellipsis',
					lineHeight: '11px',
				},
				labelFormatter: function() {
					return makeUnknownFromEmpty(this.name);
				},
			},
			tooltip: {
				shared: true,
				useHTML: true,
				backgroundColor: colors.white,
				borderWidth: 0,
				outside: true,
				borderRadius: 2,
				formatter: function() {
					const { points, x } = this;
					const total =
						points && points.reduce((acc, point) => acc + point.y, 0);

					return renderToString(
						<TooltipWrapper>
							<TooltipHeader>{x}</TooltipHeader>
							<TooltipRowPinned>
								<div />
								<TooltipRowTitle>Total spend</TooltipRowTitle>
								<TooltipRowValue>{spendFormatter(total)}</TooltipRowValue>
							</TooltipRowPinned>
							<TooltipGrid>
								{points.map(pointData => (
									<React.Fragment key={pointData.point.name}>
										<ColorWrapper>
											<ColorSymbol color={pointData.color} />
										</ColorWrapper>
										<TooltipRowTitle>{pointData.point.name}</TooltipRowTitle>
										<TooltipRowValue>
											{pointData.y
												? `${spendFormatter(pointData.y)} (${numeral(
														pointData.percentage
												  ).format('0.[00]')}%)`
												: '-'}
											{}
										</TooltipRowValue>
									</React.Fragment>
								))}
							</TooltipGrid>
						</TooltipWrapper>
					);
				},
			},
			plotOptions: {
				column: {
					groupPadding: 0.3,
				},
				series: {
					borderWidth: 0,
					pointPadding: 0,
					stacking: 'normal',
					dataLabels: {
						enabled: false,
					},
					states: {
						hover: {
							enabled: false,
						},
					},
					events: {
						legendItemClick: function() {
							return false;
						},
					},
				},
			},
			series,
		};
	};

	onChartInit = chart => {
		this.chart = chart;
	};

	render() {
		const { chartRef } = this.props;

		return (
			<ChartWrapper>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.getChartOptions()}
					ref={chartRef}
					callback={this.onChartInit}
				/>
			</ChartWrapper>
		);
	}
}
